import PackageAdditionalServiceEnum from '~/enums/PackageAdditionalServiceEnum'

export default function getServiceNameById(serviceId: PackageAdditionalServiceEnum) {
  const { t } = useLang()

  switch (serviceId) {
    case PackageAdditionalServiceEnum.InspectPackage:
      return t('site_pro.additional_services.inspect_package.title')
    case PackageAdditionalServiceEnum.ExtraPhotos:
      return t('site_pro.additional_services.extra_photos.title')
    case PackageAdditionalServiceEnum.ReturnToSender:
      return t('site_pro.additional_services.return_to_sender.title')
    case PackageAdditionalServiceEnum.AbandonPackage:
      return t('site_pro.additional_services.abandon_package.title')
  }
}
